import { facadeApi } from 'api'
import { PaginatedResponse, PaginationParams } from 'api/common/types'
import { skipEmptyParams } from 'api/common/utils'
import { TemplateResponse } from 'types/templates/templates'

export type Params = PaginationParams<{
  groupId?: string
  search?: string
  sort?: string
}>

export type TemplatesResponseData = PaginatedResponse<TemplateResponse>

export const fetchAppInstanceTemplatesApi = ({ page, itemsPerPage }: Params) =>
  facadeApi.get<TemplatesResponseData>('/app-instances/templates', {
    params: skipEmptyParams({
      page,
      itemsPerPage,
    }),
  })
